import { jsxs, jsx } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import "../shared/quiz-blank.js";
import { KatexText } from "../shared/katex-text.js";
import { QuizResultFeedback } from "../shared/quiz-result-feedback.js";
import { SubmitButton } from "../shared/submit-button.js";
import "react";
import { useTranslation } from "react-i18next";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import { QuizMedia } from "../shared/quiz-media.js";
import { QuizSolveDescription } from "../shared/quiz-solve-description.js";
import { DifficultyBadge, DebugQuizId } from "../shared/debug-quiz-id.js";
import "../../../utils/quiz-parser.js";
import { usePairingQuiz } from "../hooks/use-pairing-quiz.js";
import { motion } from "../../../node_modules/.pnpm/framer-motion@11.18.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/render/components/motion/proxy.js";
import X from "../../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/x.js";
const LINE_COLOR_DEFAULT = "#3b82f6";
function PairingAdult({
  quizId,
  quiz,
  onSolve,
  solveResult,
  showReallyTrue = false,
  isViewSolved = false,
  initialAnswers: initialAnswersProp,
  submitLabel,
  hideSubmitButton = false,
  onAnswerChange,
  disableSound = false,
  difficultyLevel
}) {
  const { t } = useTranslation("quiz");
  const {
    displayPairings,
    selected,
    lines,
    previewLine,
    hoveredPos,
    setHoveredPos,
    isSolved,
    canSubmit,
    shouldShowCorrectAnswers,
    isShowingCorrectAnswers,
    setIsShowingCorrectAnswers,
    pairs,
    containerRef,
    leftRefs,
    rightRefs,
    handleSelect,
    handleClearPairByLeft,
    handleClearPairByRight,
    handleSubmit,
    recalcLines,
    getLineColor
  } = usePairingQuiz({
    quizId,
    quiz,
    onSolve,
    solveResult,
    showReallyTrue,
    isViewSolved,
    initialAnswers: initialAnswersProp,
    onAnswerChange
  });
  return /* @__PURE__ */ jsxs("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsx(
      motion.div,
      {
        initial: { opacity: 0, y: -10 },
        animate: { opacity: 1, y: 0 },
        className: "space-y-2",
        children: /* @__PURE__ */ jsxs("div", { className: "inline-flex gap-2 items-center", children: [
          /* @__PURE__ */ jsx("div", { className: "inline-flex gap-2 items-center px-3 py-1 text-sm font-bold text-white bg-blue-500 rounded-lg", children: /* @__PURE__ */ jsx("span", { children: t("types.pairing.label") }) }),
          /* @__PURE__ */ jsx(DifficultyBadge, { level: difficultyLevel }),
          /* @__PURE__ */ jsx(DebugQuizId, { quizId })
        ] })
      }
    ),
    /* @__PURE__ */ jsxs(
      motion.div,
      {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        transition: { delay: 0.1 },
        className: cn(
          "p-6 bg-linear-to-br to-gray-50 rounded-2xl from-slate-50",
          "border border-gray-100 shadow-2xs",
          "text-2xl font-medium leading-relaxed text-gray-900"
        ),
        children: [
          /* @__PURE__ */ jsx(KatexText, { text: quiz.title }),
          /* @__PURE__ */ jsx(QuizMedia, { image: quiz.image, imageMobile: quiz.imageMobile, desmos: quiz.desmos, vars: quiz.vars })
        ]
      }
    ),
    /* @__PURE__ */ jsxs("div", { ref: containerRef, className: "relative flex", children: [
      /* @__PURE__ */ jsx("div", { className: "flex flex-col shrink-0 z-10", children: pairs.left.map((item, index) => {
        var _a, _b;
        const pairing = displayPairings[index];
        const isPaired = pairing !== null;
        const isCurrent = (selected == null ? void 0 : selected.pos) === "left" && (selected == null ? void 0 : selected.index) === index;
        const isPending = selected !== null && selected.pos !== "left";
        const isHovered = (hoveredPos == null ? void 0 : hoveredPos.pos) === "left" && (hoveredPos == null ? void 0 : hoveredPos.index) === index;
        const pairCorrect = isSolved ? (_a = solveResult == null ? void 0 : solveResult.corrects) == null ? void 0 : _a[index] : void 0;
        const isTrue = isSolved && (shouldShowCorrectAnswers || pairCorrect === true);
        const isFalse = isSolved && !shouldShowCorrectAnswers && pairCorrect === false && isPaired;
        return /* @__PURE__ */ jsxs(
          "div",
          {
            className: cn("relative cursor-pointer flex items-center mb-4 z-10", {
              "pointer-events-none": isSolved || isViewSolved
            }),
            onMouseEnter: () => setHoveredPos({ pos: "left", index }),
            onMouseLeave: () => setHoveredPos(null),
            children: [
              /* @__PURE__ */ jsxs(
                "div",
                {
                  ref: (el) => {
                    leftRefs.current[index] = el;
                  },
                  className: cn(
                    "w-[180px] md:w-[240px] gap-2 min-h-[72px] border-2 border-gray-300 text-lg font-medium text-gray-800 rounded-xl p-3 flex justify-center items-center transition-all",
                    (isHovered || isPending) && !isCurrent && !isTrue && !isFalse && "border-blue-400 text-blue-600",
                    isCurrent && "text-blue-700 bg-blue-50 border-blue-500",
                    isTrue && "border-green-400 bg-green-50 text-green-700",
                    isFalse && "border-red-400 bg-red-50 text-red-600"
                  ),
                  onClick: () => handleSelect("left", index),
                  children: [
                    ((_b = item.image) == null ? void 0 : _b.signedUrl) && /* @__PURE__ */ jsx(
                      "img",
                      {
                        src: item.image.signedUrl,
                        alt: "pairing",
                        className: "max-h-16 w-auto object-contain",
                        onLoad: recalcLines
                      }
                    ),
                    item.answer && /* @__PURE__ */ jsx("div", { className: "text-center", children: /* @__PURE__ */ jsx(KatexText, { text: item.answer }) })
                  ]
                }
              ),
              /* @__PURE__ */ jsxs(
                "div",
                {
                  className: cn(
                    "group w-7 h-7 absolute -right-3.5 top-1/2 -translate-y-1/2 overflow-hidden bg-gray-100 text-gray-500 text-xs font-semibold border-2 border-gray-300 rounded-full flex items-center justify-center z-20 cursor-pointer transition-all",
                    (isHovered || isPending) && !isCurrent && !(isCurrent || isPaired) && !isTrue && !isFalse && "bg-blue-50 border-blue-400 text-blue-500",
                    (isCurrent || isPaired) && !isTrue && !isFalse && "bg-blue-500 border-transparent text-white",
                    isTrue && "border-transparent bg-green-500 text-white",
                    isFalse && "border-transparent bg-red-500 text-white"
                  ),
                  onClick: (e) => {
                    e.stopPropagation();
                    if (isPaired) {
                      handleClearPairByLeft(index);
                    } else {
                      handleSelect("left", index);
                    }
                  },
                  children: [
                    index + 1,
                    isPaired && !isSolved && /* @__PURE__ */ jsx(
                      X,
                      {
                        className: "hidden group-hover:block absolute w-5 h-5 text-white bg-blue-500",
                        strokeWidth: 3
                      }
                    )
                  ]
                }
              )
            ]
          },
          `left-${index}`
        );
      }) }),
      /* @__PURE__ */ jsx("div", { className: "relative grow w-full min-w-[40px]" }),
      /* @__PURE__ */ jsxs(
        "svg",
        {
          className: "absolute inset-0 pointer-events-none z-0",
          style: { width: "100%", height: "100%", overflow: "visible" },
          children: [
            lines.map((line, i) => /* @__PURE__ */ jsx(
              "line",
              {
                x1: line.x1,
                y1: line.y1,
                x2: line.x2,
                y2: line.y2,
                stroke: getLineColor(line.leftIdx),
                strokeWidth: 2.5,
                strokeLinecap: "round"
              },
              i
            )),
            previewLine && /* @__PURE__ */ jsx(
              "line",
              {
                x1: previewLine.x1,
                y1: previewLine.y1,
                x2: previewLine.x2,
                y2: previewLine.y2,
                stroke: LINE_COLOR_DEFAULT,
                strokeWidth: 2.5,
                strokeLinecap: "round",
                strokeDasharray: "6 6"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsx("div", { className: "flex flex-col shrink-0 z-10", children: pairs.right.map((item, index) => {
        var _a, _b, _c;
        const isCurrent = (selected == null ? void 0 : selected.pos) === "right" && (selected == null ? void 0 : selected.index) === index;
        const isPending = selected !== null && selected.pos !== "right";
        const isHovered = (hoveredPos == null ? void 0 : hoveredPos.pos) === "right" && (hoveredPos == null ? void 0 : hoveredPos.index) === index;
        const pairedLeftIdx = displayPairings.findIndex((p) => (p == null ? void 0 : p.rightIndex) === index);
        const isPairedByAnyLeft = pairedLeftIdx !== -1;
        let isTrue = false;
        let isFalse = false;
        let dotNum = "";
        if (shouldShowCorrectAnswers) {
          const correctIdx = ((_a = solveResult == null ? void 0 : solveResult.correctAnswers) == null ? void 0 : _a.findIndex((key) => key === item.key)) ?? -1;
          if (correctIdx !== -1) {
            isTrue = true;
            dotNum = correctIdx + 1;
          }
        } else if (isSolved && isPairedByAnyLeft) {
          const pairCorrect = (_b = solveResult == null ? void 0 : solveResult.corrects) == null ? void 0 : _b[pairedLeftIdx];
          isTrue = pairCorrect === true;
          isFalse = pairCorrect === false;
          dotNum = pairedLeftIdx + 1;
        } else if (!isSolved && isPairedByAnyLeft) {
          dotNum = pairedLeftIdx + 1;
        }
        return /* @__PURE__ */ jsxs(
          "div",
          {
            className: cn("relative cursor-pointer flex items-center flex-row-reverse mb-4 z-10", {
              "pointer-events-none": isSolved || isViewSolved
            }),
            onMouseEnter: () => setHoveredPos({ pos: "right", index }),
            onMouseLeave: () => setHoveredPos(null),
            children: [
              /* @__PURE__ */ jsxs(
                "div",
                {
                  ref: (el) => {
                    rightRefs.current[index] = el;
                  },
                  className: cn(
                    "w-[180px] md:w-[240px] gap-2 min-h-[72px] border-2 border-gray-300 text-lg font-medium text-gray-800 rounded-xl p-3 flex justify-center items-center transition-all",
                    (isHovered || isPending) && !isCurrent && !isTrue && !isFalse && "border-blue-400 text-blue-600",
                    isCurrent && "text-blue-700 bg-blue-50 border-blue-500",
                    isTrue && "border-green-400 bg-green-50 text-green-700",
                    isFalse && "border-red-400 bg-red-50 text-red-600"
                  ),
                  onClick: () => handleSelect("right", index),
                  children: [
                    ((_c = item.image) == null ? void 0 : _c.signedUrl) && /* @__PURE__ */ jsx(
                      "img",
                      {
                        src: item.image.signedUrl,
                        alt: "pairing",
                        className: "max-h-16 w-auto object-contain",
                        onLoad: recalcLines
                      }
                    ),
                    item.answer && /* @__PURE__ */ jsx("div", { className: "text-center", children: /* @__PURE__ */ jsx(KatexText, { text: item.answer }) })
                  ]
                }
              ),
              /* @__PURE__ */ jsxs(
                "div",
                {
                  className: cn(
                    "group w-7 h-7 absolute -left-3.5 top-1/2 -translate-y-1/2 overflow-hidden bg-white text-gray-500 text-xs font-semibold border-2 border-gray-300 rounded-full flex items-center justify-center z-20 cursor-pointer transition-all",
                    isPending && !isCurrent && !(isCurrent || isPairedByAnyLeft) && !isTrue && !isFalse && "bg-blue-50 border-blue-400 text-blue-500",
                    isHovered && !isCurrent && !(isCurrent || isPairedByAnyLeft) && !isTrue && !isFalse && "bg-white border-blue-400 text-blue-500",
                    (isCurrent || isPairedByAnyLeft) && !isTrue && !isFalse && "bg-blue-500 border-transparent text-white",
                    isTrue && "border-transparent bg-green-500 text-white",
                    isFalse && "border-transparent bg-red-500 text-white"
                  ),
                  onClick: (e) => {
                    e.stopPropagation();
                    if (isPairedByAnyLeft) {
                      handleClearPairByRight(index);
                    } else {
                      handleSelect("right", index);
                    }
                  },
                  children: [
                    dotNum,
                    isPairedByAnyLeft && !isSolved && /* @__PURE__ */ jsx(
                      X,
                      {
                        className: "hidden group-hover:block absolute w-5 h-5 text-white bg-blue-500",
                        strokeWidth: 3
                      }
                    )
                  ]
                }
              )
            ]
          },
          `right-${index}`
        );
      }) })
    ] }),
    !isSolved && !isViewSolved && !hideSubmitButton && /* @__PURE__ */ jsx(
      SubmitButton,
      {
        onClick: handleSubmit,
        disabled: !canSubmit,
        label: submitLabel
      }
    ),
    isSolved && /* @__PURE__ */ jsx(
      QuizResultFeedback,
      {
        isCorrect: (solveResult == null ? void 0 : solveResult.correct) ?? false,
        show: isSolved,
        disableSound
      }
    ),
    isSolved && /* @__PURE__ */ jsx(
      QuizSolveDescription,
      {
        description: (solveResult == null ? void 0 : solveResult.description) ?? void 0,
        commentaryImages: quiz.commentaryImages,
        vars: quiz.vars,
        id: `${quizId}-desc`,
        actionVisible: !(solveResult == null ? void 0 : solveResult.correct),
        actionLabel: isShowingCorrectAnswers ? t("common.viewMyAnswer") : t("common.viewCorrectAnswer"),
        onActionClick: () => setIsShowingCorrectAnswers((v) => !v)
      }
    )
  ] });
}
export {
  PairingAdult
};
//# sourceMappingURL=pairing-adult.js.map
